export default "__VITE_ASSET__0nZCUDOs__"